import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './template/styles/Template.css';
import Template from './template/components/Template';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import ApiKeys from './pages/ApiKeys';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Template>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api-keys"
            element={
              <ProtectedRoute>
                <ApiKeys />
              </ProtectedRoute>
            }
          />

          {/* Placeholder routes */}
          <Route path="/news" element={<div className="placeholder-page"><h2>News Coming Soon</h2></div>} />
          <Route path="/analysis" element={<div className="placeholder-page"><h2>Analysis Coming Soon</h2></div>} />
          <Route path="/countries" element={<div className="placeholder-page"><h2>Countries Coming Soon</h2></div>} />
          <Route path="/about" element={<div className="placeholder-page"><h2>About Us Coming Soon</h2></div>} />
          <Route path="/contact" element={<div className="placeholder-page"><h2>Contact Coming Soon</h2></div>} />
          <Route path="/privacy" element={<div className="placeholder-page"><h2>Privacy Policy Coming Soon</h2></div>} />

          {/* Redirect root to dashboard or login */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Template>
    </BrowserRouter>
  );
}

export default App;